import React, {useEffect, useState} from "react"
// import zain from "../assets/icons/zain_logo.png"
import game from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import './Subscribe.scss'
import config from './../config'
import Modal from 'react-modal';
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from 'reactjs-localstorage';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width : '80%'
    },
};

Modal.setAppElement('#root');

function Mobile({setshowSideMenu}) {
    const [mobile,setMobile] = useState('')
    const [message, setMessage] = useState('')
    const [modalIsOpen, setIsOpen] = useState(false);
    let history = useHistory();

    useEffect(()=>{
        setshowSideMenu()
    },[])

    function handleChange(e) {
        setMobile(e.target.value)
    }
    function submitFrom(e) {
        e.preventDefault()
        const url = `${config.get('base')}${config.get('requestOTP')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({'msisdn': mobile}),
            headers:config.get('headers')  
            })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                if(result.status === 'success'){
                    reactLocalStorage.set("msisdn", mobile)
                    history.push('/otp')
                }else{
                    setMessage(result.message)
                    openModal()
                }
                
            },
            (error) => {
                console.log('error:::', error)
                setMessage(error)
            })
    }
    // function hideAlert(){
    //     setshowAlert(false)
    // }
    function openModal() {
        setIsOpen(true);
    }
    
    function closeModal() {
        setIsOpen(false);
    }

    function handleBtnClick(){
        closeModal()
    }
    return (
        <div className="container m-w">
             <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div>{message}</div>
                <button 
                  onClick={handleBtnClick}
                  style={{
                    width: '23%',
                    backgroundColor: 'rgb(23 54 206)',
                    color: 'white',
                    padding: '4% 1%',
                    margin: '8px 0',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                }}
                  >Okay</button>
            </Modal>
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            {/* <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo"/>
                            </figure> */}
                            <figure className="image l-s m-2">
                                <img src={game} alt="game logo"/>
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon"/>
                            </figure>
                            <form onSubmit={submitFrom}>
                                <div className="columns is-mobile is-multiline">
                                    <div className="column is-full">
                                        <div className="field">
                                            <label className="label">Enter the Mobile Number</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    type="number"
                                                    value={mobile}
                                                    onChange={handleChange}
                                                    placeholder=""/>
                                            </div>
                                            <p className="help">Please enter your number with country code</p>
                                        </div>
                                        <div className="control">
                                            <button className="button btn-main">Send OTP</button>
                                        </div>
                                        {/* {
                                            showAlert &&
                                            <div className="notification">
                                            <button className="delete" onClick={hideAlert}></button>
                                            {message}
                                        </div>
                                        } */}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Mobile